import { Col, Row } from "antd";
import React from "react";
import ReaderRecommendList from '../component/ReaderRecommendList'

const App = () => {
    return (<>
        <Row justify={'center'}>
            <Col span={22}>
                <Row gutter={[0,20]}>
                    <Col span={24}/>
                    <Col span={24}>
                        <ReaderRecommendList />
                    </Col>
                </Row>
            </Col>
        </Row>
    </>)
}

export default App